import React from 'react';
import { esconderNome, formatarTempo, camelCase, cardProbabilidadeInternacao } from '../helpers/FormatHelpers';

const TelaBuscaPaciente = ({ dataPacientes, pacienteSelecionado, dataProbabilidadeInternacao }) => {
  const dataPaciente = dataPacientes.find(paciente => paciente.CODIGOPACIENTE === pacienteSelecionado);

  if (!dataPaciente) return null;

  const processos = dataPaciente.PROCESSOS || [];
  const previsaointernacao = dataProbabilidadeInternacao.find(obj => (obj.codigoatendimento.split(' ')[1] == dataPaciente.CODIGOATENDIMENTO))?.previsaointernacao ?? null;

  return (
    <div className='tela-busca-paciente'>
      <div className='row'>
        <div className='col-md-3'>
          <div className='tela-busca-info'>
            <div>
              <span>Paciente: {esconderNome(dataPaciente.NOMEPACIENTE)}</span>
              <span>{dataPaciente.LABELPROTOCOLO}</span>
              <span>{dataPaciente.LABELCATEGORIA}</span>
            </div>
            <div>Nº atendimento: {dataPaciente.CODIGOATENDIMENTO}</div>
            <div>Class. de Risco: <span className={'alert-label ' + dataPaciente.NOMECOR} style={{ marginLeft: '5px' }}></span></div>
            <div>Especialidade/Médico: {camelCase([dataPaciente.DESCRICAOESPECIALIDADE, dataPaciente.NOMESOLICITANTE].filter(Boolean).join(' / '))}</div>
            {previsaointernacao && (
              <div>Prob. de Internação: {cardProbabilidadeInternacao( previsaointernacao, '1.6rem')}</div>
            )}
          </div>
        </div>
        <div className='col-md-9'>
          <div className='card-pacientes tela-busca-processos'>
            <div className='card-header'>
              <table>
                <thead>
                  <tr>
                    <th className='col-processos'>Processos</th>
                    <th>Aguardando</th>
                    <th className='col-espera'>Espera</th>
                    <th className='col-espera'>Espera Total</th>
                  </tr>
                </thead>
                <tbody>
                  {processos.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td className='col-processos'>{item.PROCESSO}</td>
                        <td>{item.AGUARDANDO}</td>
                        <td className='col-espera'>
                          <span className={"sla-dot " + item.COR}></span>
                          <span style={{ marginLeft: '5px' }}>{formatarTempo(item.ESPERA)}</span>
                        </td>
                        <td className='col-espera'>{formatarTempo(item.ESPERATOTAL)}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelaBuscaPaciente;